import { Component, OnInit } from '@angular/core';
import { Item } from '../item';
import { ItemService } from '../item.service';

import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BrandService } from '../../brand/brand.service';
import { Brand } from '../../brand/brand';
import { Itemcategory } from '../../item-category/item-category';
import { ItemcategoryService } from '../../item-category/item-category.service';
import { Itemuom } from '../../item-uom/item-uom';
import { ItemuomService } from '../../item-uom/item-uom.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-create-item',
  templateUrl: './create-item.component.html',
  styleUrls: ['./create-item.component.css']
})
export class CreateItemComponent implements OnInit {
  item = new Item();
  itemdata : any = {}
  submitted = false;
  brands: Brand[];
  itemcategorys: Itemcategory[];
  itemuoms: Itemuom[];  
  message: string;
  itemForm: FormGroup;
  public isupdate = false;
public FormName = "Add Item";
//gstPattern = "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$";

  constructor(
    private itemService: ItemService,
    private itemcategoryService: ItemcategoryService,
    private itemuomService: ItemuomService,
    private brandService: BrandService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private location: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.item.active = 1;
    this.getBrands();
    this.getItemcategorys();
    this.getItemuoms();
    if(this.route.snapshot.paramMap.get('itemId') != null)
			{
        const itemId = +this.route.snapshot.paramMap.get('itemId');
				 if(itemId > 0)
				 {
					 this.getItem(itemId);
				 }
				 this.isupdate = true;
				 this.FormName = "Update Item";
				 
      }
      this.itemForm = this.formBuilder.group({			
        itemname: [this.item.itemname,[Validators.required, Validators.required]],
        itemcategoryid: [this.item.itemcategoryid,[Validators.required, Validators.required]],
        itemuomid: [this.item.itemcategoryid,[Validators.required, Validators.required]],
        brandid: [this.item.brandid,[Validators.required, Validators.required]],
        gst: [this.item.gst,[Validators.required, Validators.required]],
        active: [this.item.active,[Validators.required, Validators.required]]
      });	
  }

  // convenience getter for easy access to form fields
get f() {
  return this.itemForm.controls
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.itemForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.updateItem();
    }
    else{
      this.addItem();
    }
  }
}

public addItem() {
  this.save();
}
public updateItem() {
  this.update();
}
private save(): void {
  this.itemdata = this.item;
  this.itemService.addItem(this.itemdata).subscribe(() => 
  { 
  this.util.showSuccess("Item added successfully.");
  this.router.navigate(['/items-list']);
  });
}

update(): void {
  //this.submitted = true;
  this.submitted = true;
  this.itemdata = this.item;
  //this.itemdata.modifiedby = this.auth.currentUserValue.userid;
  //this.itemdata.modifiedon = Date.now();
  this.itemService.updateItem(this.itemdata)
      .subscribe(() => 
	  { 
	  this.util.showSuccess("Item update successfully.");
      this.router.navigate(['/items-list']);
	  });
}

getBrands() {
  return this.brandService.getBrands()
             .subscribe(
               brands => {
                console.log(brands);
                this.brands = brands.filter(item => item.active == 1);
               }
              );
}

getItem(itemid) {
  return this.itemService.getItem(itemid)
             .subscribe(
              item => {
                console.log(item);
                this.item = item
               }
              );
}
getItemcategorys() {
  return this.itemcategoryService.getItemcategorys()
             .subscribe(
              itemcategorys => {
                this.itemcategorys = itemcategorys
               }
              );
}
getItemuoms() {
  return this.itemuomService.getItemuoms()
             .subscribe(
              itemuoms => {
                this.itemuoms = itemuoms
               }
              );
}
}
